import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@webapp/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-648c83f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-icon",
  src: _imports_0
}, null, -1))

import { ref, onMounted } from 'vue'
import { usePageTitle } from '@webapp/util/AppUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import Spinner from '@webapp/util/Spinner.vue'
import ContactForm from './ContactForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactPage',
  setup(__props) {

const isValidRef = ref(false)
const busyRef = ref(false)
const isSentRef = ref(false)
const formRef = ref<InstanceType<typeof ContactForm>>()

usePageTitle("Contact us")

onMounted(() => {
  isSentRef.value = false
  formRef.value?.reset()
})

async function onSubmitTicket() {
  try {
    busyRef.value = true
    await formRef.value?.submitTicket()
    isSentRef.value = true
  } finally {
    busyRef.value = false 
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TaskPage, {
    class: "container-lg",
    "no-brand": "",
    "no-back": "",
    "no-action": isSentRef.value,
    "can-continue": isValidRef.value && !busyRef.value,
    onAction: onSubmitTicket
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(" Contact us ")
    ]),
    actionText: _withCtx(() => [
      (busyRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(Spinner),
            _createTextVNode(" Sending... ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Send ")
          ], 64))
    ]),
    default: _withCtx(() => [
      _createVNode(ContactForm, {
        ref_key: "formRef",
        ref: formRef,
        "is-valid": isValidRef.value,
        "onUpdate:isValid": _cache[0] || (_cache[0] = ($event: any) => ((isValidRef).value = $event))
      }, null, 8, ["is-valid"])
    ]),
    _: 1
  }, 8, ["no-action", "can-continue"]))
}
}

})